import * as React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { Box, Breadcrumbs } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    margin: '20px 0',
    padding: '0 20px',
    [theme.breakpoints.down('md')]: {
      margin: '20px 0',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px',
    },
    '&>div': {
      margin: '0 auto',
      maxWidth: `${theme.maxWidth}px`,
    },
  },
  breadcrumb: {
    '& *': {
      color: theme.palette.text.secondary,
      fontSize: 14,
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
  },
  besttour: {
  },
  webSiteName: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  item: {
    '&.last': {
      color: theme.palette.text.label,
    },
  },
}));


/** 麵包屑導航 */
export function PageTitle({data}) {

  const classes = useStyles();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  return (
    <Box className={classes.root}>
      <Box>
        <Breadcrumbs aria-label='breadcrumb' className={classes.breadcrumb} >

          <a href='https://www.besttour.com.tw' >
            <Box className={classes.besttour}>喜鴻假期</Box>
          </a>

          <Link to={'/'}>
            <Box className={classes.webSiteName}>{global.domain.webSiteName}</Box>
          </Link>

          {data.map((item, index) => (
            <Box
              key={`pageTitle_${index}`}
              className={clsx(classes.item, index < data.length - 1 ? null : 'last')}
            >{item}</Box>
          ))};
          
        </Breadcrumbs>
      </Box>
    </Box>
  );
}